import { IConfig } from '@cian/config/shared';

import { getNewbuildingCardPromosAnchor } from './getNewbuildingCardPromosAnchor';
import { UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY } from '../../constants/config';
import { ESiteType } from '../siteType';

interface IGetNewbuildingCardUrlParams {
  uniquePromoId: string;
  siteType: ESiteType;
  config: IConfig;
  baseUrl: string;
}

export function getNewbuildingCardUrl({
  uniquePromoId,
  siteType,
  config,
  baseUrl,
}: IGetNewbuildingCardUrlParams): string {
  const uniquePromoIdParam = config.get<string>(UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY) ?? 'uniquePromoId';

  const uniquePromoIdQueryParams = `${uniquePromoIdParam}=${uniquePromoId}`;
  const anchor = getNewbuildingCardPromosAnchor(siteType);

  return `${baseUrl}?${uniquePromoIdQueryParams}${anchor}`;
}
